import { PromoService } from "../services";

const promoCode = {
    data() {
        return {
            promo: {
               amount: 0
            },
            promoCode: null,
        }
    },
   mounted() {
        this.setPromoCode();
   },
    methods: {
        async setPromoCode() {
            this.promoCode = new URLSearchParams(window.location.search).get('promo') ?? null;

            try {
                const { data: { promo } } = await PromoService.submit({
                    code: this.promoCode
                });

                this.promo = promo;
                this.promoCode = promo && promo.name;
                this.updatePromoCodeQuery(promo && promo.name);
            } catch (e) {
                throw new Error(e);
            }
        },
        submitPromoCode() {
            if (this.promoCode) {
                axios.post('/promo-code', { code: this.promoCode })
                    .then(response => {
                        const { promo } = response.data;
                        const { name = null , error = null } = promo || {};

                        if (name !== null) {
                            this.showSuccessMessage('Your promo code was successfully submitted');

                            this.promo = promo;
                            this.promoCode = promo.name;
                            this.updatePromoCodeQuery(promo.name);
                        } else {
                            if (error !== null) {
                                this.showErrorMessage(error);
                            } else {
                                this.showErrorMessage('You have entered the wrong code');
                            }
                        }
                    }).catch(error => {
                        console.log(error)
                    });
            } else {
                this.showErrorMessage('Promo code should not be empty!');
            }
        },
        updatePromoCodeQuery(promo) {
            const currentUrl = new URL(window.location.href);

            currentUrl.searchParams.set('promo', promo);

            window.history.pushState({}, '', currentUrl.toString());
        },
    }
}

export default promoCode
